import { render, staticRenderFns } from "./SavePointModal.vue?vue&type=template&id=d6b00aa8&scoped=true"
import script from "./SavePointModal.vue?vue&type=script&lang=js"
export * from "./SavePointModal.vue?vue&type=script&lang=js"
import style0 from "./SavePointModal.vue?vue&type=style&index=0&id=d6b00aa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b00aa8",
  null
  
)

export default component.exports